// extracted by mini-css-extract-plugin
export default {"input":"Input1_input__xlXTl","passwordWrapper":"Input1_passwordWrapper__0lkos","passwordInput":"Input1_passwordInput__mfNrb","visibilityToggle":"Input1_visibilityToggle__8PHd4"};